import {Component, inject} from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {ChipsModule} from "primeng/chips";
import {Ripple} from "primeng/ripple";
import {ButtonDirective} from "primeng/button";
import {AuthService} from "../../auth/auth.service";
import {FormsModule} from "@angular/forms";
import {MessagesModule} from "primeng/messages";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CheckboxModule,
    ChipsModule,
    Ripple,
    ButtonDirective,
    FormsModule,
    MessagesModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  authService: AuthService = inject(AuthService);
  router: Router = inject(Router);

  msgs = [{severity:'error', detail: 'Invalid credentials'}]

  username: string = ''
  password: string = ''

  failed = false;

  login() {
    this.authService.login(this.username, this.password).subscribe((response: any) => {
      if (!this.authService.token) {
        this.failed = true;
        return
      }

      this.router.navigate(['/groups']).then(r => {});
    })

  }
}
